import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faAmbulance,
  faAngleDown,
  faAngleUp,
  faBars,
  faBatteryFull,
  faBookOpen,
  faBug,
  faCalendar,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faClock,
  faCloudDownloadAlt,
  faEdit,
  faExclamationTriangle,
  faExternalLinkAlt,
  faFighterJet,
  faFileExport,
  faFileDownload,
  faFlask,
  faHistory,
  faHome,
  faKeyboard,
  faListAlt,
  faListUl,
  faLongArrowAltLeft,
  faLongArrowAltRight,
  faMoon,
  faPlus,
  faPowerOff,
  faQuestionCircle,
  faSave,
  faSearch,
  faSignOutAlt,
  faSpinner,
  faSprayCan,
  faSun,
  faSync,
  faTachometerAlt,
  faTimes,
  faTrash,
  faUpload,
  faUser,
  faUserMd,
  faUsers,
  faWifi,
  faWrench,
  faLeaf,
  faShoppingCart,
  faCompass,
} from '@fortawesome/free-solid-svg-icons'

import { faCircle as farCircle } from '@fortawesome/free-regular-svg-icons'

import { faGoogle } from '@fortawesome/free-brands-svg-icons'

export default {
  initLibrary: (): void => {
    library.add(
      faAmbulance,
      faAngleDown,
      faAngleUp,
      faBars,
      faBatteryFull,
      faBookOpen,
      faBug,
      faCalendar,
      faChevronDown,
      faChevronLeft,
      faChevronRight,
      faCircle,
      faClock,
      faCloudDownloadAlt,
      faEdit,
      faExclamationTriangle,
      faExternalLinkAlt,
      faFighterJet,
      faFileExport,
      faFileDownload,
      faFlask,
      faGoogle,
      faHistory,
      faHome,
      faKeyboard,
      faListAlt,
      faListUl,
      faLongArrowAltLeft,
      faLongArrowAltRight,
      faMoon,
      faPlus,
      faPowerOff,
      faQuestionCircle,
      farCircle,
      faSave,
      faSearch,
      faSignOutAlt,
      faSpinner,
      faSprayCan,
      faSun,
      faSync,
      faTachometerAlt,
      faTimes,
      faTrash,
      faUpload,
      faUser,
      faUserMd,
      faUsers,
      faWifi,
      faWrench,
      faLeaf,
      faShoppingCart,
      faCompass,
    )
  },
}
